'use client';

import { Typography } from '@/shared/ui/atoms';
import { CheckBox } from '@/shared/ui/atoms';

interface ConsultServiceCheckCardProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  name: string;
  description: string;
}

const ConsultServiceCheckCard = ({ checked, onChange, name, description }: ConsultServiceCheckCardProps) => {
  return (
    <div className="flex w-full h-[4rem] py-[0.75rem] md:py-0 md:items-center px-[11px] md:h-[4.812rem] border border-gray-200 rounded-lg cursor-pointer">
      <div className="flex items-start gap-[0.75rem] md:gap-[0.88rem]">
        <div className="flex-shrink-0">
          <CheckBox checked={checked} width={18} height={18} uncheckedBgColor="white" checkedColor="#6B00D7" border={{ color: '#E5E7EF', borderWidth: '1px', radius: '4px' }} onChange={onChange} />
        </div>
        <div className="flex flex-col gap-[0.06rem]" onClick={() => onChange(!checked)}>
          <Typography as="p" className="text-[0.938rem] md:text-[1rem] leading-[1.375rem] font-medium text-gray-700">
            {name}
          </Typography>
          <Typography as="p" className="text-[0.875rem] md:text-[0.875rem] leading-[1.125rem] font-medium text-coolNeutral-50 whitespace-nowrap md:whitespace-normal">
            {description}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default ConsultServiceCheckCard;
